/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button[_ngcontent-%COMP%]{background:rgba(0,0,0,.8);color:#fff}"];
export { styles as styles };
